// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHealthPlanTierFamilyCountDto
 */
export interface IHealthPlanTierFamilyCountDto {
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanTierFamilyCountDto
     */
    tier_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanTierFamilyCountDto
     */
    family_count?: number;
}

/**
 * Check if a given object implements the IHealthPlanTierFamilyCountDto interface.
 */
export function instanceOfIHealthPlanTierFamilyCountDto(value: object): value is IHealthPlanTierFamilyCountDto {
    return true;
}

export function IHealthPlanTierFamilyCountDtoFromJSON(json: any): IHealthPlanTierFamilyCountDto {
    return IHealthPlanTierFamilyCountDtoFromJSONTyped(json, false);
}

export function IHealthPlanTierFamilyCountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPlanTierFamilyCountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'tier_name': json['tier_name'] == null ? undefined : json['tier_name'],
        'family_count': json['family_count'] == null ? undefined : json['family_count'],
    };
}

export function IHealthPlanTierFamilyCountDtoToJSON(json: any): IHealthPlanTierFamilyCountDto {
    return IHealthPlanTierFamilyCountDtoToJSONTyped(json, false);
}

export function IHealthPlanTierFamilyCountDtoToJSONTyped(value?: IHealthPlanTierFamilyCountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tier_name': value['tier_name'],
        'family_count': value['family_count'],
    };
}

